import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { PrivateRoute } from "widgets/PrivateRoute";

import clientRoutes from "views";

const RoutesComponent: FC = () => {
  return (
    <Routes>
      {clientRoutes.map(({ path, element, Layout, isPrivate, layoutProps }) => {
        const routeElement = Layout ? <Layout {...layoutProps}>{element}</Layout> : element;

        return (
          <Route
            key={path}
            path={path}
            element={isPrivate ? <PrivateRoute>{routeElement}</PrivateRoute> : routeElement}
          />
        );
      })}
    </Routes>
  );
};

export default React.memo(RoutesComponent);
